import { forwardRef } from "react";
import clsx from "clsx";

export const ContainerOuter = forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div">
>(function OuterContainer({ className, children, ...props }, ref) {
  return (
    <div ref={ref} className={clsx("sm:px-6", className)} {...props}>
      <div className="mx-auto w-full max-w-7xl lg:px-6">{children}</div>
    </div>
  );
});

export const ContainerInner = forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div">
>(function InnerContainer({ className, children, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={clsx("relative px-6 lg:px-12", className)}
      {...props}
    >
      {children}
    </div>
  );
});

export const Container = forwardRef<
  React.ElementRef<typeof ContainerOuter>,
  React.ComponentPropsWithoutRef<typeof ContainerOuter>
>(function Container({ children, ...props }, ref) {
  return (
    <ContainerOuter ref={ref} {...props}>
      <ContainerInner>{children}</ContainerInner>
    </ContainerOuter>
  );
});

export const ContainerWide = forwardRef<
  React.ElementRef<typeof ContainerOuter>,
  React.ComponentPropsWithoutRef<typeof ContainerOuter>
>(function Container({ children, ...props }, ref) {
  return (
    <div ref={ref} className={clsx("", props.className)} {...props}>
      <div ref={ref} className={clsx("relative px-6 lg:px-12")}>
        <div className="mx-auto">{children}</div>
      </div>
    </div>
  );
});

export const ContainerThin = forwardRef<
  React.ElementRef<typeof ContainerOuter>,
  React.ComponentPropsWithoutRef<typeof ContainerOuter>
>(function Container({ children, ...props }, ref) {
  return (
    <div ref={ref} className={clsx("", props.className)} {...props}>
      <div ref={ref} className="relative px-6 lg:px-12 flex justify-center">
        <div className="mx-auto max-w-2xl w-full">{children}</div>
      </div>
    </div>
  );
});

export const ContainerHome = forwardRef<
  React.ElementRef<typeof ContainerOuter>,
  React.ComponentPropsWithoutRef<typeof ContainerOuter>
>(function Container({ children }, ref) {
  return (
    <div ref={ref} className="relative pl-[16px] md:pl-[60px] md:pr-[60px] max-w-[1080px] overflow-hidden">
      <div className="mx-auto">{children}</div>
    </div>
  );
});
